import React from "react";
import { useScreenTransitionManager } from "@jugl-web/utils/utils/ScreenTransitionManager";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useTranslations } from "@jugl-web/utils";
import { CRMAccountTile } from "../CRMAccountTile";
import { ManageAccountsDrawerScreenToParametersMap } from "../../types";
import { ReactComponent as TwilioBorderedIcon } from "./assets/twilio.svg";
import defaultAvatar from "./assets/default-avatar.png";
import { useManageAccountsDrawer } from "../../providers/ManageAccountsDrawerContext";

export const TwilioAccountCard: React.FC<{
  isClickable?: boolean;
}> = ({ isClickable }) => {
  const { t } = useTranslations();
  const { entity } = useEntitySelectedProvider();
  const { transitionTo } =
    useScreenTransitionManager<ManageAccountsDrawerScreenToParametersMap>();

  const { crmConfig } = useManageAccountsDrawer();

  const config = crmConfig?.twilio;

  const handleClick = () => {
    if (!isClickable || config?.id) {
      return;
    }
    transitionTo({ name: "twilioAccount" });
  };

  return (
    <CRMAccountTile
      title={
        config?.phone_num ||
        t({
          id: "client-support-page.text-sms-chat",
          defaultMessage: "Text (SMS) Chat",
        })
      }
      isConnected={!!config?.id}
      onClick={handleClick}
      img={entity.logoImg || undefined}
      defaultAvatar={defaultAvatar}
      icon={TwilioBorderedIcon}
      status={config?.id ? "accountIsEnabled" : "disabled"}
      description={
        !config?.id
          ? t({
              id: "client-support-page.twilio-is-disabled-tile",
              defaultMessage:
                "Quick and easy way for business communications. Enable Text (SMS) Chat to start 📈",
            })
          : undefined
      }
    />
  );
};
